<template>
  <textarea-autosize
    :min-height="minHeight"
    class="w-full outline-none text-area leading-normal"
  />
</template>

<script>
export default {

  name: 'BaseTextArea',
  props: {
    minHeight: {
      type: Number,
      default: null,
    },
  },
};
</script>

<style lang="scss" scoped>
.text-area::placeholder {
  color: #7A838E;
}
</style>
